import { render } from "./EditPassword.vue?vue&type=template&id=00896caa&scoped=true&ts=true"
import script from "./EditPassword.vue?vue&type=script&lang=ts"
export * from "./EditPassword.vue?vue&type=script&lang=ts"

import "./EditPassword.vue?vue&type=style&index=0&id=00896caa&lang=scss&scoped=true"

import exportComponent from "D:\\project\\anet\\new2h5\\libo\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00896caa"]])

export default __exports__